import styled from 'styled-components';
import * as antd from 'antd';

export const Alert = styled(antd.Alert)`
  margin-bottom: 1rem;
`;
